import { apiClient } from '../../../api/client'
import type { ExecutiveSummary } from '../types'

/** Bir etkinliğin Yönetici Özeti (029; salt-okunur). Yok/aktif değil → 404. */
export async function getExecutiveSummary(id: number): Promise<ExecutiveSummary> {
  const { data } = await apiClient.get<ExecutiveSummary>(`/management/activities/${id}`)
  return data
}
